module.exports = __webpack_public_path__ + "static/media/empty-search.f85ec76c.png";